'use strict';

import angular from 'angular';
import ngCookies from 'angular-cookies';
import uiRouter from '@uirouter/angularjs';

/* controllers */
import contactCtrl from './contact/contactCtrl';
import imageContentCtrl from './imageContent/imageContentCtrl';
import joinCtrl from './join/joinCtrl';
import modelCtrl from './model/modelCtrl';
import producerCtrl from './producer/producerCtrl';
import modelsListCtrl from './modelsList/modelsListCtrl';
import tourCtrl from './tour/tourCtrl';
import trailerCtrl from './trailer/trailerCtrl';
import updatesListCtrl from './updatesList/updatesListCtrl';
import videoContentCtrl from './videoContent/videoContentCtrl';
import mainCtrl from './main/mainCtrl';


/* @ngInject */
export default angular.module('core.features', [ngCookies, uiRouter])
  .controller(mainCtrl.UID, mainCtrl)
  .controller(contactCtrl.UID, contactCtrl)
  .controller(imageContentCtrl.UID, imageContentCtrl)
  .controller(joinCtrl.UID, joinCtrl)
  .controller(modelCtrl.UID, modelCtrl)
  .controller(producerCtrl.UID, producerCtrl)
  .controller(modelsListCtrl.UID, modelsListCtrl)
  .controller(tourCtrl.UID, tourCtrl)
  .controller(trailerCtrl.UID, trailerCtrl)
  .controller(updatesListCtrl.UID, updatesListCtrl)
  .controller(videoContentCtrl.UID, videoContentCtrl)
  .name;



// WEBPACK FOOTER //
// ./~/site_core/src/features/index.js